/** @format */

export default function() {
  return [
    {
      title: '车场名称',
      dataIndex: 'parkName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '车牌号',
      dataIndex: 'plate',
      width: 140,
      scopedSlots: { customRender: 'click-to-detail' }
    },
    {
      title: '入场时间',
      dataIndex: 'enterTime',
      width: 200,
      sortable: true
    },
    {
      title: '入场通道',
      dataIndex: 'enterChannelName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '停车时长',
      dataIndex: 'parkingTime',
      width: 180,
      sortable: true,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '车辆类型',
      dataIndex: 'authTypeName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse-to-tip' }
    },
    {
      title: '查看车辆图片',
      dataIndex: 'image',
      width: 160,
      scopedSlots: { customRender: 'viewImg' }
    }
    // {
    //   title: '操作',
    //   dataIndex: 'operation',
    //   fixed: 'right',
    //   width: 154,
    //   scopedSlots: { customRender: 'operation' },
    // },
  ];
}
